
namespace GeniuzPOS.AdvPromo {
    export class Adv05ItemExDTsColumns {
        static columnsKey = 'AdvPromo.Adv05ItemExDTs';
    }
}